
import React, {useRef, useState} from 'react';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {
  FormControl,
  IconButton,
  TextField,
  Tooltip,
} from '@material-ui/core';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import {ErrorTooltip} from '../../../../../components/Tooltips';
const DateFieldTable = ({
  dateStampFields,
  setDateStampFields,
  dateStampFieldDeleteRef,
  editExisting,
  DataManagerAccess,
  handleBlur,
  touched,
  values,
  errors,
  setFieldValue,
}) => {
  const [isDelete, setIsDelete] = useState(false);
  const deleteRef = useRef(null);

  const handleDateStampChange = (i, property, value) => {
    const copyArr = [...dateStampFields];
    copyArr[i][property] = value;
    setDateStampFields(copyArr);
  };

  const reorderItems = (startIndex, endIndex) => {
    const arr = [...dateStampFields];
    const [removed] = arr.splice(startIndex, 1);
    arr.splice(endIndex, 0, removed);
    setDateStampFields(arr);
  };

  const onDragEnd = (result) => {
    const {source, destination} = result;
    if (!destination) {
      return;
    }
    reorderItems(source.index, destination.index);
  };

  const handleDelete = (rowData, key) => {
    deleteRef.current = rowData;
    setIsDelete(true);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
  };

  const handleConfirmDelete = () => {
    const arr = dateStampFields.filter((r) => r.fieldName !== deleteRef.current.fieldName);
    if (deleteRef.current.reportDateStampId) {
      const newArr = dateStampFieldDeleteRef.current.filter(
        (el) => el !== deleteRef.current.reportDateStampId,
      );
      newArr.push(deleteRef.current.reportDateStampId);
      dateStampFieldDeleteRef.current = newArr;
    } else if (deleteRef.current?.dataRepositoryId) {
      const newArr = dateStampFieldDeleteRef.current.filter(
        (el) => el !== deleteRef.current.dataRepositoryId,
      );
      newArr.push(deleteRef.current.dataRepositoryId);
      dateStampFieldDeleteRef.current = newArr;
    }
    setDateStampFields(arr);
    handleCloseDialog();
  };


  const columns = [
    {
      title: 'Actions',
      field: 'actions',
    },
    {
      title: 'Seq',
      field: 'seq',
    },
    {
      title: 'Repository',
      field: 'repository',
    },
    {
      title: 'Field Name',
      field: 'fieldName',
    },

    {
      title: 'Value',
    },
    // {
    //   title: "Print Subtotal",
    // },
  ];
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Field"
        value={`Are you sure you want to delete the ${deleteRef.current?.fieldName} Field?`}
        handleSubmit={handleConfirmDelete}
      />
      <div
        className={`new-standard-textfields  mui-custom-table-container custom-table  pt-0 global-field-table text-center-table`}
      >
        <DragDropContext onDragEnd={onDragEnd}>
          <table>
            <thead className="recFormat-header-container">
              <tr>
                {columns.map(
                  ({title, hidden = false}) =>
                    !hidden && (
                      <th key={title} className="recFormat-header">
                        {title}
                      </th>
                    ),
                )}
              </tr>
            </thead>
            <Droppable droppableId="droppabe-list">
              {(provided) => (
                <tbody ref={provided.innerRef} className="recFormat-body">
                  {dateStampFields?.length > 0 ? (
                    dateStampFields.map((rowData, index) => {
                      const currField = rowData.fieldName + rowData.repositoryName;
                      return (
                        <Draggable key={index} draggableId={'draggable-' + index} index={index}>
                          {(provided) => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <td className="recFormat-col recFormat-center">
                                <Tooltip title="Delete">
                                  <IconButton
                                    disabled={
                                      (editExisting && !DataManagerAccess?.edit)
                                    }
                                    onClick={(e) => {
                                      handleDelete(rowData, index);
                                    }}
                                  >
                                    <DeleteOutlined />
                                  </IconButton>
                                </Tooltip>
                              </td>
                              <td className="recFormat-col global-field-textfields">{index + 1}</td>
                              <td className="recFormat-col global-field-textfields">
                                {rowData.repositoryName}
                              </td>
                              <td className="recFormat-col global-field-textfields report-table-textfields">
                                <div
                                  style={{
                                    width: '170px !important',
                                    margin: '0px auto !important',
                                  }}
                                >
                                  {rowData.fieldName}
                                </div>
                              </td>

                              <td className="recFormat-col global-field-textfields report-table-textfields">
                                <div className="report-table-field date-stamp-value">
                                  <FormControl margin="dense" variant="outlined" fullWidth>
                                    <ErrorTooltip
                                      title={
                                        errors['dateValue' + currField] ?
                                          errors['dateValue' + currField] :
                                          ''
                                      }
                                    >
                                      <TextField
                                        margin="dense"
                                        variant="outlined"
                                        //   className={` ${classes.labelName}`}
                                        // placeholder={
                                        //   values?.fieldsName?.fieldType?.toLowerCase() === "date"
                                        //     ? "MM/DD/YYYY or T+/T-"
                                        //     : `Enter ${field.paramLabel}`
                                        // }
                                        placeholder="MM/DD/YYYY or Today or T"
                                        //   onBlur={handleBlur}
                                        // label={field.paramLabel}
                                        label={'Values'}
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        name={'dateValue' + index}
                                        touched={touched?.['dateValue' + currField]}
                                        required
                                        value={values['dateValue' + currField]}
                                        onChange={(e) => {
                                          setFieldValue('dateValue' + currField, e.target.value.toUpperCase());
                                          handleDateStampChange(index, 'dateValue', e.target.value);
                                        }}
                                        error={Boolean(errors['dateValue' + currField])}
                                        onBlur={handleBlur}
                                        fullWidth
                                      />
                                      {/* <FormHelperText>
                                      {touched["dateValue" + index] &&
                                        errorDateEmpty }
                                    </FormHelperText> */}
                                    </ErrorTooltip>
                                  </FormControl>
                                </div>
                              </td>
                              {/* <td className="recFormat-col global-field-textfields field-2 report-table-textfields">
                                <div className="format-field report-table-field">
                                  <FormControl margin="dense" variant="outlined" fullWidth>
                                    <Select
                                      fullWidth
                                      name="printTotal"
                                      className="select-gender"
                                      required
                                      disabled={rowData?.fieldType !== "Number"}
                                      value={rowData.printTotal || "none"}
                                      onChange={(event) => {
                                        handleSortFieldChange(
                                          index,
                                          "printTotal",
                                          event.target.value
                                        );
                                      }}
                                    >
                                      <MenuItem value="none" key="none" disabled>
                                        Select Any
                                      </MenuItem>
                                      {SubTotalsOptions.map((option) => {
                                        return (
                                          <MenuItem value={option.key} key={option.key}>
                                            {option.value}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                </div>
                              </td> */}
                            </tr>
                          )}
                        </Draggable>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={columns.length}>
                        No records to display. To add Date Stamp to your record click the &quot;+ Date
                        Stamp&quot; button in the top right of this section.
                      </td>
                    </tr>
                  )}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </div>
    </>
  );
};

export default DateFieldTable;
